import React from "react";
import { Card, Col } from "react-bootstrap";
import { Analysts, Title, PublicationDate, MinutesRead, Synopsis } from "../tileView/PublicationCardParts";
import { ShareButton } from "../../shareMenu/ShareButton";
import "./featured.css";

export function FeaturedPubCard({ publication, styles, lang, imageUrl }) {
  const ImageStyles = {
    img: {
      maxHeight: "220px",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "scroll",
      backgroundPosition: "center",
      backgroundSize: "cover",
      margin: 0,
      backgroundImage: `url('${imageUrl}')`,
      height: "25vh",
    },
  };
  return (
    <Col
      key={publication.id}
      lg={publication.lg || 4}
      md={publication.md || 6}
      sm={publication.sm || 6}
      xs={12}
      className="d-flex flex-column pb-2 px-2"
    >
      <Card lang="en" className="bg-white text-dark w-100 rounded-0 shadow card" style={ImageStyles.img} />
      <Card
        className={`${styles.card || ""} w-100 rounded-0 shadow card-body-grow`}
        style={styles.cardStyle}
        lang={lang}
      >
        <Card.Header className={`${styles.header || ""} border-bottom-0`}>
          <Analysts lang={lang} {...publication} styles={styles} />
        </Card.Header>

        <Card.Body className={`${styles.body} py-0 publication-synopsis`}>
          <Card.Title className={`${styles.title || ""}`}>
            <Title {...publication} />
          </Card.Title>
          <Synopsis {...publication} styles={styles} />
        </Card.Body>

        <Card.Footer className={`border-top-0 ${styles.footer || ""}`}>
          {publication?.language !== "ja" && <MinutesRead wordCount={publication?.instrumentation?.wordCount || 0} />}
          <PublicationDate {...publication} />
          <ShareButton publication={publication} />
        </Card.Footer>
      </Card>
    </Col>
  );
}
